import React, { useEffect } from "react";

function FileSelector({ onFileSelect, hideFileInput }) {
  useEffect(() => {
    const fetchData = () => {
      const defaultFile = `/Barcode.json?t=${new Date().getTime()}`;

      fetch(defaultFile)
        .then((response) => response.json())
        .then((data) => onFileSelect(data))
        .catch((error) => console.error("Error fetching default file:", error));
    };

    fetchData();

    const interval = setInterval(fetchData, 30000);

    return () => clearInterval(interval);
  }, [onFileSelect]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = JSON.parse(e.target.result);
        onFileSelect(data);
      };
      reader.readAsText(file);
    }
  };

  if (hideFileInput) {
    return null;
  }

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
    </div>
  );
}

export default FileSelector;
